import React, { useState, useEffect } from 'react'
import { Card, List, Row, Col, message, Table, Empty, Typography } from 'antd'
import {
  EyeFilled,
  EditFilled,
  PlayCircleFilled
} from '@ant-design/icons';
import { platformApi } from '../../../api'
import AudioPlayback from './AudioPlayback';
import ActivityEditor from './ActivityEditor';
import BookingActivity from './ActivityTemplate/BookingActivity'
import QuotationActivity from './ActivityTemplate/QuotationActivity';
import MessageActivity from './ActivityTemplate/MessageActivity';
import WalkInActivity from './ActivityTemplate/WalkInActivity';

import './style.less'
import moment from 'moment';
import CallActivity from './ActivityTemplate/CallActivity';
import DiscardActivity from './ActivityTemplate/DiscardActivity';
import ServiceFollowUpActivity from './ActivityTemplate/ServiceFollowupActivity';
import ServiceWhatsAppActivity from './ActivityTemplate/ServiceWhatsAppActivity';
import WhatsAppActivity from './ActivityTemplate/WhatsAppActivity';
const ActivityLog = (props) => {
  const { customerId, dataSource, setDataSource, getActivityByCustomer } = props
  const [visible, setVisibility] = useState(false);
  const [editorVisibility, setEditor] = useState(false)
  const [editable, setEditable] = useState(false)
  const [activityId, setActivityId] = useState(null)
  const defaultLimit = 15;
  const [limit, setLimit] = useState(defaultLimit);
  const [offset, setOffset] = useState(0);
  const { Text, Title } = Typography
  const { Meta } = Card

  const openEditor = (id, edit = false) => {
    setActivityId(id)
    setEditable(prev => edit)
    setEditor(true)
  }


  const renderAction = (item) => {
    return <PlayCircleFilled onClick={() => setVisibility(!visible)} />
  }

  const isCallInteraction = (type) =>
    type === "Outgoing Call" ||
    type === "Incoming Call" ||
    type === "Missed Call" ||
    type === "Incoming Missed Call" ||
    type === "Outgoing Missed Call" ||
    type === "Call Unanswered" ||
    type === "Call Follow";

  const isWalkInInteraction = (type) =>
    type === "WALK IN" || type === "Walk In" || type === "WALK-IN";

  // Categorize by activity kind first. A linked quotation must NOT force
  // "Quotation Activity" for walk-in / call rows.
  const renderTitle = (item) => {
    const itype = item.interactionType;

    if (item.booking) {
      return <BookingActivity item={item} openEditor={openEditor} />;
    }
    if (itype === "Service Followup WhatsApp Message") {
      return <ServiceWhatsAppActivity item={item} openEditor={openEditor} />;
    }
    if (
      itype === "Service Followup Call" ||
      itype === "Service Followup Message"
    ) {
      return <ServiceFollowUpActivity item={item} openEditor={openEditor} />;
    }
    if (itype === "WhatsApp Message") {
      return <WhatsAppActivity item={item} openEditor={openEditor} />;
    }
    if (item.sms) {
      return <MessageActivity item={item} openEditor={openEditor} />;
    }
    if (
      item.callId ||
      item.callHistoryId ||
      item.callHistory ||
      isCallInteraction(itype)
    ) {
      return <CallActivity item={item} openEditor={openEditor} />;
    }
    if (isWalkInInteraction(itype)) {
      return <WalkInActivity item={item} openEditor={openEditor} />;
    }
    if (item.discardMsg || itype === "Discard") {
      return <DiscardActivity item={item} openEditor={openEditor} />;
    }
    if (item.quotation) {
      return <QuotationActivity item={item} openEditor={openEditor} />;
    }
    return <WalkInActivity item={item} openEditor={openEditor} />;
  };


  return (
    <div className="activity-log">
      <Card title={<Title style={{ textAlign: 'center' }} level={4}>Activity</Title>}>
        <List
          itemLayout="horizontal"
          dataSource={dataSource}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={
                  renderTitle(item)
                }
              />
              <AudioPlayback
                audioSource={item}
                visible={visible}
                setVisibility={setVisibility}
              />
            </List.Item>
          )}
        />
      </Card>
      {editorVisibility && <ActivityEditor
        editable={editable}
        activityId={activityId}
        getActivities={getActivityByCustomer}
        visible={editorVisibility}
        setVisibility={setEditor}
      />}
    </div>
  )
}

export default ActivityLog;
